module.exports = {
	"Basic 1": [
		{
			"statement": "Explain the use of definite article with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of indefinite articles with two examples.",
			"image": ""
		},
		{
			"statement": "Present the use of verb to be in the affirmative, negative, and interrogative.",
			"image": ""
		},
		{
			"statement": "Present the use of question words who and what with one example of each.",
			"image": ""
		},
		{
			"statement": "Present the use of four prepositions of place with one example of each.",
			"image": ""
		},
		{
			"statement": "Present the use of question word where with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of question word when with two examples.",
			"image": ""
		},
		{
			"statement": "Present two greetings and two farewells.",
			"image": ""
		},
		{
			"statement": "Select two adjectives to describe physical characteristics and give examples with them.",
			"image": ""
		},
		{
			"statement": "Explain the difference between demonstrative pronouns.",
			"image": ""
		},
		{
			"statement": "Select two family members and give examples with them.",
			"image": ""
		},
		{
			"statement": "Select two adjectives to describe places in the city and give examples with them.",
			"image": ""
		}
	],
	"Basic 2": [
		{
			"statement": "Explain the use of auxiliary verbs do and does in the simple present.",
			"image": ""
		},
		{
			"statement": "Explain the use of present continuous with structure and two examples.",
			"image": ""
		},
		{
			"statement": "Explain the difference between question words how often and when.",
			"image": ""
		},
		{
			"statement": "Explain the use of adverbs of frequency with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of there + to be with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of intensifiers with two examples.",
			"image": ""
		},
		{
			"statement": "Present four activities related to household chores.",
			"image": ""
		},
		{
			"statement": "Present four activities related to work tasks.",
			"image": ""
		},
		{
			"statement": "Explain the rules of plural forms and give examples for each rule.",
			"image": ""
		},
		{
			"statement": "Select three adjectives to describe personal characteristics and give examples with them.",
			"image": ""
		},
		{
			"statement": "Select three adjectives related to places and give examples with them.",
			"image": ""
		},
		{
			"statement": "Select three adjectives related to places in a house and furniture and give examples with them.",
			"image": ""
		}
	],
	"Basic 3": [
		{
			"statement": "Explain the use of auxiliary verb did in the simple past.",
			"image": ""
		},
		{
			"statement": "Present the use of verbs take, get, have, make, do, and keep in the simple past.",
			"image": ""
		},
		{
			"statement": "List three nouns that do not accept plural forms and provide two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of how much in questions.",
			"image": ""
		},
		{
			"statement": "Explain the use of how many in questions.",
			"image": ""
		},
		{
			"statement": "Explain the use of some and any in affirmative and negative sentences.",
			"image": ""
		},
		{
			"statement": "Explain the use of objective pronouns with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of used to with two examples.",
			"image": ""
		},
		{
			"statement": "Select three leisure activities and give examples with them.",
			"image": ""
		},
		{
			"statement": "Select three activities related to work and give examples with them.",
			"image": ""
		},
		{
			"statement": "Select three countable and three uncountable nouns and present them.",
			"image": ""
		},
		{
			"statement": "Select three words related to food or kitchen objects and give examples with them.",
			"image": ""
		}
	],
	"Intermediate 1": [
		{
			"statement": "Explain the use of modal verb will with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of modal verb should with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of modal verb must with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of modal verb can with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of modal verb could with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the difference between simple past and past continuous with two examples.",
			"image": ""
		},
		{
			"statement": "Explain how to ask for someone’s opinion providing three examples.",
			"image": ""
		},
		{
			"statement": "Explain how to give opinion expressing certainty and doubt with two examples.",
			"image": ""
		},
		{
			"statement": "Select two expressions used when eating out and give examples with them.",
			"image": ""
		},
		{
			"statement": "Select two expressions with the modal verb will and give examples with them.",
			"image": ""
		},
		{
			"statement": "Give examples with the connectors when and while.",
			"image": ""
		},
		{
			"statement": "Explain the use of reflexive pronouns with two examples.",
			"image": ""
		}
	],
	"Intermediate 2": [
		{
			"statement": "Explain how to express agreement and disagreement with two examples for each situation.",
			"image": ""
		},
		{
			"statement": "Explain the use of comparative of superiority.",
			"image": ""
		},
		{
			"statement": "Explain the use of comparative of inferiority.",
			"image": ""
		},
		{
			"statement": "Explain the use of comparative of equality.",
			"image": ""
		},
		{
			"statement": "Explain the use of superlative forms.",
			"image": ""
		},
		{
			"statement": "Explain the use of modal verb may with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of modal verb might with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of modal verb would with two examples.",
			"image": ""
		},
		{
			"statement": "Explain how to give opinion in a formal and informal way with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of to be going to with two examples.",
			"image": ""
		},
		{
			"statement": "Select one connector of addition, one of contrast and one of conclusion and give examples with them.",
			"image": ""
		},
		{
			"statement": "Select two expressions used at the airport and give examples with them.",
			"image": ""
		}
	],
	"Intermediate 3": [
		{
			"statement": "Explain the use of present perfect (continuity) with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of present perfect (relevance) with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of present perfect continuous.",
			"image": ""
		},
		{
			"statement": "Explain how to defend your opinion by supporting with a narrative—give one example.",
			"image": ""
		},
		{
			"statement": "Explain how to defend your opinion by analyzing positive and negative aspects—give one example.",
			"image": ""
		},
		{
			"statement": "Explain the use of present perfect with ever and already—give two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of would you mind for request and favor—give two examples.",
			"image": ""
		},
		{
			"statement": "Present verbs that are followed only by gerund or infinitive with two examples.",
			"image": ""
		},
		{
			"statement": "Select one expression used to give good news and one to give bad news and give examples with them.",
			"image": ""
		},
		{
			"statement": "Select two strategies to give advice and give examples with them.",
			"image": ""
		},
		{
			"statement": "Select two expressions used to explain procedures and give examples with them.",
			"image": ""
		},
		{
			"statement": "Select one paired conjunction and give an example with them.",
			"image": ""
		}
	],
	"Advanced 1": [
		{
			"statement": "Explain the use of past perfect with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of past perfect continuous with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of modal verb must + perfect infinitive with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of modal verb should + perfect infinitive with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of reminders when explaining procedures with two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of connectors of cause and consequence with two examples.",
			"image": ""
		},
		{
			"statement": "Explain how to ask for clarification when listening to procedures.",
			"image": ""
		},
		{
			"statement": "Explain the structure of passive voice and when to use it—give two examples.",
			"image": ""
		},
		{
			"statement": "Select two expressions related to bank and investments and give examples with them.",
			"image": ""
		},
		{
			"statement": "Give a definition in a subtle way.",
			"image": ""
		},
		{
			"statement": "Select two connectors of condition and give examples with them.",
			"image": ""
		},
		{
			"statement": "Select one connector of cause and effect and give an example with them.",
			"image": ""
		}
	],
	"Advanced 2": [
		{
			"statement": "Explain the use of future prefect with two examples.",
			"image": ""
		},
		{
			"statement": "Explain how to report commands with two examples.",
			"image": ""
		},
		{
			"statement": "Explain how to report yes/no questions with two examples.",
			"image": ""
		},
		{
			"statement": "Explain how to report content questions with two examples.",
			"image": ""
		},
		{
			"statement": "Explain how to use adverbs to make a definition less or more emphatic—give two examples.",
			"image": ""
		},
		{
			"statement": "Explain the use of modal verbs may and might + perfect infinitive with one example for each.",
			"image": ""
		},
		{
			"statement": "Choose two verbs and explain their meaning.",
			"image": ""
		},
		{
			"statement": "Explain the use of modal verb would + perfect infinitive with two examples.",
			"image": ""
		},
		{
			"statement": "Select two expressions related to politics and give examples with them.",
			"image": ""
		},
		{
			"statement": "Select two expressions used to summarize and give examples with them.",
			"image": ""
		},
		{
			"statement": "Select one proverb and give an example with them.",
			"image": ""
		},
		{
			"statement": "Select one expression used to complain and one to show surprise and give examples with them.",
			"image": ""
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/tasks.json
// module id = 673
// module chunks = 0